function cssIdGenerator(id: number) {
  const alpha = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j"];
  let code = "";
  const strinfifiedId = id.toString();

  for (let index = 0; index < strinfifiedId.length; index++) {
    code += alpha[id[index]]?.toUpperCase() || "";
  }
  return code;
}

export { cssIdGenerator };
